//
// Theme global preloader
//

(function ($, waTheme) {

    // Прелоадер страниц
    var GlobalPreloader = (function ($) {

        GlobalPreloader = function (options) {
            var that = this;

            // DOM
            that.$wrapper = options['$wrapper'];

            // VARS
            that.delay = options['delay'];
            that.time = options['time'];

            // DYNAMIC VARS

            // EVENTS
            that.init();
        };

        GlobalPreloader.prototype.init = function () {
            var that = this;

            if (that.$wrapper.length) {
                that.hide();
            }
        };

        GlobalPreloader.prototype.hide = function () {
            var that = this;
            that.$wrapper.delay(that.delay).fadeOut(that.time);
        };

        GlobalPreloader.prototype.show = function () {
            var that = this;
            that.$wrapper
                .css({
                    'opacity': '50%',
                    'background-color': '#161c2d',
                })
                .delay(5)
                .fadeIn(25);
        };

        return GlobalPreloader;

    })($);

    waTheme.init.site.GlobalPreloader = GlobalPreloader;

    var $wrapper = $(".b-global-preloader");
    if ($wrapper.length) {
        $wrapper.each(function () {
            waTheme.apps["site"].GlobalPreloader = new window.waTheme.init.site.GlobalPreloader({
                $wrapper: $(this),
            });
        });
    }

})(jQuery, window.waTheme);
